<template>
    <form id="deposit_form" class="border p-2" @submit.prevent="submit">
        <kt-row>
            <kt-col xs="12" class="mb-5">
        <span v-if="deposit.logo == null">
            <img src="/assets/media/image-not-found.png" style="max-width:300px" class="d-block m-auto"
                 :title="$t('label.image_not_found')"/>
        </span>
                <span v-else>
            <img :src="deposit.logo" style="max-width:300px" class="d-block m-auto">
        </span>
            </kt-col>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="user_full_name">
                        {{ $t('label.User_full_name') }} {{' :'}}
                    </kt-form-label>
                    <router-link :to="'/users/'+ deposit.user_id +'/details'">
                        {{deposit.user_fullname}}
                    </router-link>
                </kt-form-group>
            </kt-col>

            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="farsi_name">
                        {{ $t('label.farsi_name') }}
                    </kt-form-label>
                    <kt-form-control
                            id="farsi_name"
                            name="farsi_name"
                            v-model="deposit.farsi_name"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="english_name">
                        {{ $t('label.english_name') }}
                    </kt-form-label>
                    <kt-form-control
                            id="english_name"
                            name="english_name"
                            v-model="deposit.english_name"
                            dir="ltr"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="deposit_sequence">
                        {{ $t('label.gateway_id') }}
                    </kt-form-label>
                    <kt-form-control
                            id="deposit_sequence"
                            name="deposit_sequence"
                            disabled
                            :value="deposit.sequence"
                            dir="ltr"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>

            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="created_at">
                        {{ $t('label.created_at') }}
                    </kt-form-label>
                    <kt-form-control
                            dir="ltr"
                            id="created_at"
                            name="created_at"
                            disabled
                            :value="deposit.created_at"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
          <kt-col xs="12">
            <kt-form-group>
              <kt-form-label for="callback_address">
                {{ $t('label.callback_address') }}
              </kt-form-label>
              <kt-form-control
                  id="callback_address"
                  name="callback_address"
                  v-model="deposit.callback_address"
                  dir="ltr"
              >
              </kt-form-control>
            </kt-form-group>
          </kt-col>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="wallet_hashid">
                        {{ $t('label.wallet_hashid') }}
                    </kt-form-label>
                    <kt-form-control
                            dir="ltr"
                            id="wallet_hashid"
                            name="wallet_hashid"
                            v-model="deposit.wallet_hashid"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col xs="12">
                <kt-form-group>
                    <div class="custom-control custom-switch">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="merchant_has_payer"
                            name="merchant_has_payer"
                            v-model="deposit.merchant_has_payer"
                        >
                        <label class="custom-control-label" for="merchant_has_payer">{{
                                $t('deposit.merchant_has_payer') }}</label>
                    </div>
                </kt-form-group>
            </kt-col>
            <kt-col xs="12" v-if="accounts_status == 'success'">
                <kt-form-group>
                    <kt-form-label for="destination_account_id">
                        {{ $t('deposit.destination_account_id') }}
                    </kt-form-label>
                    <select
                            id="destination_account_id"
                            name="destination_account_id"
                            class="form-control kt-selectpicker"
                            v-model="deposit.destination_account_id"
                    >
                        <option value=""></option>
                        <option
                                v-bind:key="index"
                                v-for="(account, index) in bank_accounts"
                                :selected="deposit.destination_account_id == account.id"
                                :value="account.id"
                        >
                            {{ account.sheba }}
                        </option>
                    </select>
                </kt-form-group>
            </kt-col>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="destination_bank">
                        {{ $t('deposit.destination_bank') }}
                    </kt-form-label>
                    <kt-form-select
                            id="destination_bank"
                            name="destination_bank"
                            v-on:change="setBankAccounts(false)"
                            class="form-control kt-selectpicker"
                            v-model="deposit.destination_bank"
                    >
                        <option value=""></option>
                        <option
                                :selected="deposit.destination_bank == bank"
                                v-bind:key="bank"
                                v-for="bank in depositDestinationBanks"
                                :value="bank"
                        >
                            {{ depositDestinationBankStr.get(bank) }}
                        </option>
                    </kt-form-select>
                </kt-form-group>
            </kt-col>
            <kt-col  xs="8" sm="8">
                <kt-col></kt-col>
                <kt-form-action class="mt-4">
                    <button
                            class="btn btn-md btn-primary btn-wide"
                            type="button"
                            data-toggle="modal"
                            data-target="#access-ips-modal"
                            id="access_ips_btn"
                    >
                        {{ $t('application.access_ips') }}
                    </button>
                </kt-form-action>
            <div id="access-ips-modal" class="modal fade" role="dialog"
            >
                <div class="modal-dialog">
                    <!-- Modal content-->
                    <div class="modal-content" id="access-ips-modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">
                                {{ $t('application.access_ips') }}
                            </h4>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">

                            <div v-for="(access_ip,index) in deposit.access_ips" :key="index">
                                <kt-row>
                                    <kt-col xs="7" sm="7">
                                        <kt-form-group>
                                            <kt-form-control :value="access_ip" dir="ltr"
                                                             :name="'access_ips.'+index"
                                                             v-model="deposit.access_ips[index]"
                                                             :id="index"></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="3" sm="3">
                                        <kt-form-group>
                                            <a @click="deleteAccessIp(index)"
                                               class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-danger btn-bold float-right">
                                                <i class="la la-trash-o"></i>
                                                {{ $t('btn.delete') }}
                                            </a>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-row>
                            </div>
                            <kt-row id="add_access_ip">
                                <kt-col xs="9" sm="9">
                                    <kt-form-group>
                                        <kt-form-control dir="ltr" v-model="new_access_ip"
                                                         name="new_access_ip"
                                                         id="new_access_ip"></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="3" sm="3">
                                    <kt-form-group hor style="margin-right: 2%">
                                        <a style="padding-top: 10%" @click="addAccessIp()"
                                           class="btn btn-bold btn-sm btn-label-brand">
                                            <i class="la la-plus"></i> {{ $t('btn.add') }}
                                        </a>
                                    </kt-form-group>
                                </kt-col>
                            </kt-row>
                        </div>
                    </div>
                </div>
            </div>

            </kt-col>
            <kt-col xs="12">
                <kt-form-action class="mt-4">
                    <kt-button
                            class="m-2"
                            size="md"
                            variant="success"
                            type="submit"
                            v-bind:wide="true"
                            id="submit_btn"
                    >
                        {{ $t('btn.edit') }}
                    </kt-button>
                </kt-form-action>
            </kt-col>
        </kt-row>
    </form>
</template>

<script>
import $ from 'jquery';
import {KTApp} from '@/plugins/core/app';
import {KTUtil} from '@/plugins/core/util';
import {depositPfService, depositStarshopService } from "@/common/api.service"
import {i18n} from '@/plugins/i18n';
import {mapGetters} from "vuex";
import {depositDestinationBanks, depositDestinationBankStr} from "@/constants/deposit";
import toastr from "toastr";

export default {
    data() {
        return {
            'hashid': this.$route.params.hashid,
            depositDestinationBanks, depositDestinationBankStr,
            bank_accounts: [],
            new_access_ip : null,
            depositPfService,
            depositStarshopService
        };
    },
    props: {
        deposit: {
            required: true,
        }
    },
    computed: {
        gatewaySource() {
            return this.$route.params.gateway_source;
        },
        apiService() {
            return this.$route.params.gateway_source === 'pf' ? this.depositPfService : this.depositStarshopService;
        },
        ...mapGetters('deposit', {
            status: 'status',
            accounts: 'accounts',
            accounts_status: 'accounts_status'
        }),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    watch: {
        status: {
            handler(newValue, oldValue) {
                if (newValue == 'setFormData' && this.general_setting_status == 'success')
                    this.setBankAccounts(true)
            }
        },
        accounts_status: {
            handler(newValue, oldValue) {
                if (newValue == 'success' && this.status == 'setFormData')
                    this.setBankAccounts(true)
            }
        }
    },
    mounted() {
        this.$store.dispatch('deposit/getAccounts', this.gatewaySource === 'starshop')
        this.afterDispatch()
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            });
        },
        submit(e) {
            let form = $('#deposit_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    wallet_hashid: {
                        required: true
                    },
                  callback_address: {
                        required: true
                    },
                }
            });


            if (!form.valid()) {
                return
            }
            if (!this.checkIfIsPersian(this.deposit.farsi_name)) {
                form.validate().showErrors({
                    farsi_name: i18n.t('pos.validations.enter_persian')
                })
            }
            if (!this.checkIfIsEnglish(this.deposit.english_name)) {
                form.validate().showErrors({
                    english_name: i18n.t('pos.validations.enter_english')
                })
            }

            KTApp.progress(btn)

            let params = this.$store.getters['deposit/form_data']
            // let form_data = new FormData

            this.apiService.updateByAdmin(this.hashid, params).then(response => {
                this.showMsg(form, 'success', response.data.message);
                KTUtil.scrollTop();
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        setBankAccounts(is_first_set) {
            this.bank_accounts = []
            if (!is_first_set)
                this.deposit.destination_account_id = ''
            this.accounts.forEach((account) => {
                if (account.bank_name == this.deposit.destination_bank)
                    this.bank_accounts.push(account)
            })
        },
        addAccessIp() {
            var ip_regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
            if (!ip_regex.test(this.new_access_ip))
                return this.toastr.error(i18n.t('application.message.invalid_ip_format'))

            for (var i = 0; i < this.deposit.access_ips.length; i++) {
                if (this.deposit.access_ips[i] === this.new_access_ip)
                    return this.toastr.error(i18n.t('application.message.ip_is_duplicate'))
            }

            this.deposit.access_ips.push(this.new_access_ip)
            if (this.deposit.access_ips.length >= 4)
                document.getElementById('add_access_ip').style.display = 'none'
            this.new_access_ip = null
        },
        deleteAccessIp(index) {
            this.deposit.access_ips.splice(index, 1)

            if (this.deposit.access_ips.length < 4)
                document.getElementById('add_access_ip').style.display = 'flex'
        },
    }
}
</script>

<style>

</style>